<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table #dt [value]="indicadores" [columns]="cols" dataKey="id"
                     selectionMode="multiple" [(selection)]="indicadoresSeleccionados"
                     [rowHover]="true" [rows]="10" [paginator]="true"
                     [scrollable]="false" [responsive]='true'
                     [filterDelay]="0" [globalFilterFields]="['clase','clase','tipo','titulo']"
                     sortMode="multiple" [multiSortMeta]="multiSortMeta"
                     [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                     styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <button pButton pRipple
                                type="button" 
                                label="{{appConfig.ux.actions.create }}"
                                icon="pi pi-plus"
                                (click)="nuevoIndicador();">
                        </button>
                        <span class="p-input-icon-left ml-1 w-full">
                            <i class="pi pi-search"></i>
                            <input
                                pInputText
                                type="text"
                                (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Buscar.." 
                                class="w-full"/>
                        </span>
                    </div>
                </ng-template>

                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <!--                        <th style="width: 3rem">
                                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                            </th>-->
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{col.header}}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </div>
                        </th>
                        <th style="width: 12rem">{{'Acciones'}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns"r>
                    <tr>
                        <!--                        <td style="width: 3rem">
                                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                            </td>-->
                        <td *ngFor="let col of columns" [hidden]="!col.visible">
                            {{rowData[col.field]}}
                        </td>
                        <td style="width: 12rem">
                            <button pButton type="button" 
                                    pTooltip="{{appConfig.ux.actions.edit}}" tooltipPosition="bottom" 
                                    icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                                    (click)="editarIndicador(rowData);"
                                    [disabled]="puedeEjecutar('escritura')">
                            </button>
                            <button                                     pButton type="button" 
                                                                        pTooltip="{{appConfig.ux.actions.delete}}" tooltipPosition="bottom" 
                                                                        icon="pi pi-trash" class="p-button-rounded p-button-text p-button-secondary"
                                                                        (click)="confirmarBorrarIndicador(rowData);"
                                                                        [disabled]="puedeEjecutar('borrado')">
                            </button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">{{appConfig.ux.emptyMsg}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="dt.reset();">
                    </button>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<p-dialog [header]="(indicador && indicador.id) ? 'Editar Indicador' : 'Nuevo Indicador'" 
          [(visible)]="mostrarEditor" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditor=false;">


    <ng-template pTemplate="header">
        <div class="text-700 w-full">
            <div class="text-900 text-2xl">
                {{indicador.id ? 'Editar indicador' 
                : 'Crear indicador'}}
            </div>
        </div>
    </ng-template>
    <form #indicadorEditorForm="ngForm"
          (ngSubmit)="guardarIndicador();"
          [ngClass]="{'disabledForm': false}"><!-- indicadorEditorForm.reset();-->
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid grid">

            <div class="field col-12">
                <h2 class="p-text-uppercase">{{indicador.titulo}}</h2>
            </div>

            <div class="field col-8">
                <label for="titulo">Título</label>
                <input #titulo="ngModel" id="titulo" name="titulo" type="text" 
                       [(ngModel)]="indicador.titulo"
                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                           *ngIf="indicadorEditorForm.controls['titulo']
                           && !indicadorEditorForm.controls['titulo'].valid 
                           && (indicadorEditorForm.controls['titulo'].dirty 
                           || indicadorEditorForm.controls['titulo'].touched)">
                </p-message>
            </div>

            <div class="field col-4">
                <label for="tipo">Tipo de gráfico</label>
                <p-dropdown #dd id="tipo" name="tipo" 
                            [options]="tiposDeIndicador" optionLabel="name" optionValue="value" 
                            [(ngModel)]="indicador.tipoSelected" 
                            placeholder="Seleccione un tipo..."
                            emptyMessage="No se encontraron registros."
                            emptyFilterMessage="No se han encontrado resultados."
                            [showClear]="true" [filter]="false" autoDisplayFirst="true"
                            [showTransitionOptions]="'.0s'" [hideTransitionOptions]="'.0s'"
                            required>
                    <ng-template pTemplate="selectedItem">
                        <div class="country-item item-value" *ngIf="indicador.tipoSelected">
                            <i [class]="indicador.tipoSelected.toLowerCase() == 'grafico' ? 'pi pi-fw pi-chart-bar' : 'pi pi-fw pi-table'"
                               style="margin:0 5px 0 0"></i>{{indicador.tipoSelected}}
                        </div>
                    </ng-template>
                    <ng-template let-tipo pTemplate="item">
                        <div class="country-item item-value">
                            <i [class]="tipo.value.toLowerCase() == 'grafico' ? 'pi pi-fw pi-chart-bar' : 'pi pi-fw pi-table'"
                               style="margin:0 5px 0 0"></i>{{tipo.name}}
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>


            <div class="field col-12" *ngIf="(indicador && indicador.tipoSelected=='grafico')">

                <div class="col-12" style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 0.5rem; background: #e0e0e0">
                    <h6 class="p-text-bold">Configuración específica del gráfico: </h6>

                    <div class="field col-12 md-12">
                        <label for="clase">Clase de gráfico</label>
                        <p-dropdown #dd id="clase" name="clase" 
                                    [options]="clasesDeGrafico" optionLabel="name" optionValue="value" 
                                    [(ngModel)]="indicador.claseSelected" 
                                    placeholder="Seleccione el tipo de gráfico"
                                    emptyMessage="No se encontraron registros."
                                    emptyFilterMessage="No se han encontrado resultados."
                                    [showClear]="true" [filter]="false" autoDisplayFirst="true"
                                    [showTransitionOptions]="'.0s'" [hideTransitionOptions]="'.0s'"
                                    required>
                            <ng-template pTemplate="selectedItem">
                                <div class="country-item item-value" *ngIf="indicador.claseSelected">
                                    <i [class]="indicador.claseSelected.toLowerCase() == 'bar' ? 'pi pi-fw pi-chart-bar' : 'pi pi-fw pi-chart-line'"
                                       style="margin:0 5px 0 0"></i>{{indicador.claseSelected}}
                                </div>
                            </ng-template>
                            <ng-template let-clase pTemplate="item">
                                <div class="country-item item-value">
                                    <i [class]="clase.value.toLowerCase() == 'bar' ? 'pi pi-fw pi-chart-bar' : 'pi pi-fw pi-chart-line'"
                                       style="margin:0 5px 0 0"></i>{{clase.name}}
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label for="tituloX">Título de Eje X</label>
                        <input #tituloX="ngModel" id="tituloX" name="tituloX" type="text" 
                               [(ngModel)]="indicador.titulo_eje_x" 
                               [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                               required pInputText>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                                   *ngIf="indicadorEditorForm.controls['tituloX']
                                   && !indicadorEditorForm.controls['tituloX'].valid 
                                   && (indicadorEditorForm.controls['tituloX'].dirty 
                                   || indicadorEditorForm.controls['tituloX'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label for="tituloY">Título de Eje Y</label>
                        <input #tituloY="ngModel" id="tituloY" name="tituloY" type="text" 
                               [(ngModel)]="indicador.titulo_eje_y" 
                               [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                               required pInputText>
                        <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                                   *ngIf="indicadorEditorForm.controls['tituloY']
                                   && !indicadorEditorForm.controls['tituloY'].valid 
                                   && (indicadorEditorForm.controls['tituloY'].dirty 
                                   || indicadorEditorForm.controls['tituloY'].touched)">
                        </p-message>
                    </div>
                </div>
            </div>
            <div class="field col-12">
                <label for="descripcion">Json</label>
                <textarea #descripcion="ngModel" id="descripcion" name="descripcion" type="text"
                          [(ngModel)]="indicador.json" 
                          [pattern]="appConfig['validationRegExp']['jsonPatternSql']"
                          [rows]="10"
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['jsonPatternSql']" 
                           *ngIf="indicadorEditorForm.controls['descripcion'] 
                           && !indicadorEditorForm.controls['descripcion'].valid 
                           && (indicadorEditorForm.controls['descripcion'].dirty 
                           || indicadorEditorForm.controls['descripcion'].touched)">
                </p-message>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditor=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!indicadorEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton type="button" 
                label="No"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton type="button" 
                label="Sí"
                icon="pi pi-check" class="p-ml-2"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>